import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { Observable } from 'rxjs';
import { UsfProductCardModeEnum } from '../../../../../../shared/constants/usf-product-card-mode.enum';
import {
  AddToInventoryViewModel,
  SelectableRecentPurchaseProduct,
  SelectedProduct,
} from '../../../../../models/add-to-inventory-view-model.model';

@Component({
  selector: 'app-add-to-inventory',
  templateUrl: './add-to-inventory.component.html',
  styleUrls: ['./add-to-inventory.component.scss'],
})
export class AddToInventoryComponent {
  mode: UsfProductCardModeEnum = UsfProductCardModeEnum.addToInventory;
  @Input() viewModel$: Observable<AddToInventoryViewModel>;
  @Output()
  selectProductEmitter: EventEmitter<SelectedProduct> = new EventEmitter();
  @Output()
  selectAllProductsEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output()
  searchEmitter: EventEmitter<string> = new EventEmitter();
  @Output()
  selectMultipleProductsEmitter: EventEmitter<
    SelectedProduct[]
  > = new EventEmitter();
  searchKey = '';

  constructor(
    readonly platformService: PlatformService,
    readonly translateService: TranslateService,
    private modalController: ModalController,
  ) {}

  trackItem(index: any, item: any) {
    return item ? index : undefined;
  }

  selectProduct(product: SelectableRecentPurchaseProduct) {
    this.selectProductEmitter.emit({
      productNumber: product.productNumber,
      value: !product.isSelected,
    });
  }

  selectAllProducts(allProducts: SelectedProduct[]) {
    // Using alternate emitter because the select all call did not consider our search restriction
    this.selectMultipleProductsEmitter.emit(allProducts);
  }

  deselectAllProducts() {
    this.selectAllProductsEmitter.emit(false);
  }

  back() {
    this.deselectAllProducts();
    this.modalController.dismiss({
      numberOfProductsSelected: 0,
    });
  }

  addToInventory(viewModel: AddToInventoryViewModel) {
    this.modalController.dismiss({
      numberOfProductsSelected: viewModel.numberOfProductsSelected,
    });
  }

  onSearchChange() {
    this.searchEmitter.next(this.searchKey);
  }

  resetSearch() {
    this.searchKey = '';
    this.searchEmitter.next('');
  }
}
